import { useEffect } from 'react';
import { FullStory, isInitialized } from '@fullstory/browser';

// `crossOriginIframe` isn't a documented FullStory operation — it's a custom
// name our old hand-rolled snippet defined; unclear why fs.js still honors
// it. The Lumis widget's own snippet expects a host to call this to stitch:
// https://github.com/Updater/lumis-tvi-app/blob/main/vite-plugins/inject-fullstory.ts
const registerCrossOriginIframe = (iframe: HTMLIFrameElement) => {
  (
    FullStory as unknown as (
      operation: string,
      options: { iframe: HTMLIFrameElement }
    ) => void
  )('crossOriginIframe', { iframe });
};

export function useFullstoryCrossOriginIframes(enabled: boolean) {
  useEffect(() => {
    const widgetBaseUrl = process.env.NEXT_PUBLIC_WIDGET_BASE_URL;
    if (!enabled || !widgetBaseUrl) return;

    function registerIfWidget(node: Node) {
      if (
        node instanceof HTMLIFrameElement &&
        node.src.startsWith(widgetBaseUrl!) &&
        isInitialized()
      ) {
        registerCrossOriginIframe(node);
      }
    }

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach(registerIfWidget);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    document.querySelectorAll<HTMLIFrameElement>('iframe').forEach((el) => {
      if (el.src.startsWith(widgetBaseUrl) && isInitialized()) {
        registerCrossOriginIframe(el);
      }
    });

    return () => observer.disconnect();
  }, [enabled]);
}
